import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as R from "ramda";

import { Div } from "components/Base";

import Divider from "@material-ui/core/Divider";
import MenuItem from "@material-ui/core/MenuItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";

import { getFilesList, getSelectOptions } from "../../selectors";
import { getters, actions } from "../../model";
import css from "./styles.scss";
import cx from "classnames";

const decorate = R.compose(
  connect(
    state => ({
      fileList: getFilesList(state),
      selectOptions: getSelectOptions(state),
      uploadHasFinished: getters.fileUploadUploadHasFinished(state)
    }),
    {
      updateFileData: actions.updateFileUploadFileData,
      disbledUploadButton: actions.setFileUploadUploadHasFinished
    }
  )
);

const SelectOptions = ({
  selectInfo,
  fileList,
  updateFileData,
  uploadId,
  selectOptions,
  defaultValue,
  hide,
  disbledUploadButton,
  uploadHasFinished,
  viaPortal
}) => {
  const useStyles = makeStyles({
    rootSelect: {
      fontSize: 12,
      fontWeight: 800,
      maxWidth: viaPortal ? 120 : 80,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    listItem: {
      "& > li": {
        fontSize: 12
      }
    }
  });
  const classes = useStyles();
  // @TODO: Fix this with a selector or local states
  useEffect(() => {
    setTimeout(() => {
      disbledUploadButton(true);
    }, 2000);
  }, []);

  return (
    <Div
      style={{
        display: "flex",
        flexDirection: "row",
        minWidth: viaPortal ? "100%" : "50%",
        width: viaPortal ? "100%" : "50%",
        ...(!viaPortal
          ? { alignItems: "center", justifyContent: "space-around" }
          : {}),
        ...(viaPortal ? { gap: "8px" } : {})
      }}
      className={cx(css.flex__container, {
        [css.selectOptions]: viaPortal
      })}
    >
      {hide ? null : (
        <>
          {selectOptions[selectInfo].title}:
          <div>
            <FormControl>
              <Select
                value={defaultValue ? defaultValue : ""}
                autoWidth
                displayEmpty
                disableUnderline
                MenuProps={{
                  dense: true,
                  classes: {
                    list: classes.listItem
                  }
                }}
                disabled={!uploadHasFinished}
                onChange={e => {
                  e.preventDefault();
                  disbledUploadButton(false);
                  updateFileData({
                    value: e.target.value,
                    type: selectInfo,
                    uploadId
                  });
                }}
                classes={{
                  select: classes.rootSelect
                }}
              >
                {selectOptions[selectInfo].hasNew && (
                  <MenuItem value={selectOptions[selectInfo].valueNew}>
                    {selectOptions[selectInfo].textNew}
                  </MenuItem>
                )}
                {selectOptions[selectInfo].hasNew && (
                  <ListSubheader>
                    {selectOptions[selectInfo].separator}
                  </ListSubheader>
                )}

                {selectInfo === "versions" &&
                  fileList.map(opt => (
                    <MenuItem value={opt.id}>{opt.title}</MenuItem>
                  ))}
                {selectInfo !== "versions" &&
                  selectOptions[selectInfo].options.map(opt => (
                    <MenuItem value={opt.value}>{opt.text}</MenuItem>
                  ))}
              </Select>
            </FormControl>
          </div>
          {viaPortal ? null : <Divider orientation="vertical" flexItem />}
        </>
      )}
    </Div>
  );
};

export default decorate(SelectOptions);
